import React from "react";
import PropTypes from "prop-types";
import { PaginationLink, StepperWrapper } from "./styled";
import NextPageIcon from "./icons/NextPageIcon";
import LastPageIcon from "./icons/LastPageIcon";

const ForwardSteppers = props => {
  const { currentPage, numberOfPages, pathRoot } = props;

  return (
    <StepperWrapper>
      <PaginationLink
        key="pagination-next"
        className={currentPage === numberOfPages ? "disabled" : ""}
        /* 
          Do not put {to = currentPage + 1} if already on last page
          Even though it will be disabled, it would resolve to a 404 and 
          having it on the page would be detrimental to SEO 
        */
        to={`${pathRoot}/${
          currentPage === numberOfPages ? currentPage : currentPage + 1
        }`}
      >
        <NextPageIcon disabled={currentPage === numberOfPages} />
      </PaginationLink>
      <PaginationLink
        key="pagination-end"
        className={`hide-on-mobile ${
          currentPage === numberOfPages ? "disabled" : ""
        }`}
        to={`${pathRoot}/${numberOfPages}`}
      >
        <LastPageIcon disabled={currentPage === numberOfPages} />
      </PaginationLink>
    </StepperWrapper>
  );
};

ForwardSteppers.propTypes = {
  pathRoot: PropTypes.string,
  currentPage: PropTypes.number,
  numberOfPages: PropTypes.number
};

ForwardSteppers.defaultProps = {
  pathRoot: "",
  currentPage: 1,
  numberOfPages: 1
};

export default ForwardSteppers;
